import { iFirestoreStorage, iFirestoreProfilePicStorage, iFirestoreProfileCoverStorage } from './firestore-storage.types';
import { FirestoreProfilePicStorage } from './storages/firestore-profile-pic.storage';
import { FirestoreProfileCoverStorage } from './storages/firestore-profile-cover.storage';

export class FirestoreStorage implements iFirestoreStorage {
  public profilePic: iFirestoreProfilePicStorage;

  public profileCover: iFirestoreProfileCoverStorage;

  constructor(
    rootRef: firebase.storage.Reference,
  ) {
    this.profilePic = new FirestoreProfilePicStorage(rootRef);
    this.profileCover = new FirestoreProfileCoverStorage(rootRef);
  }
}
